import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type SchoolFilter,
} from '../types/filters';
import { schoolDefinition, schoolHandler } from './school';

export const multiSchoolDefinition: FilterDefinition<
  MultiFilter<SchoolFilter>
> = {
  id: FilterId.MULTI_SCHOOL,
  name: 'School',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.SCHOOL,
  instances: [],
  isVisible: true,
};

export const multiSchoolHandler: FilterHandler<MultiFilter<SchoolFilter>> = {
  isActive(currentFilterState: MultiFilter<SchoolFilter>) {
    return currentFilterState.instances.some((instance) =>
      schoolHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<SchoolFilter>,
    _definition: FilterDefinition<MultiFilter<SchoolFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<SchoolFilter>,
    _definition: FilterDefinition<MultiFilter<SchoolFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      schoolHandler.getEffectiveFilter(instance, schoolDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
